import { NormalizedCacheObject } from '@apollo/client'
import { initializeApollo } from 'lib/apolloClient'
import { isServer } from 'lib/utils'
import { NextPageContext } from 'next'

export default function prefetchDetectedMarket(
  ctx: NextPageContext,
): { initialApolloState: NormalizedCacheObject } | Record<string, never> {
  if (isServer()) {
    const apolloClient = initializeApollo(ctx)

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }
  return {}
}
